import { Product } from '../types/catalog'

/** Aggregate products exactly as they appear on the 2026 price list. */
export const products: Product[] = [
  {
    id: 'p-42024',
    name: 'Mineral Aggregate, Type 17',
    category: 'Fill / structural',
    cosSpec: 'Type 17',
    productNumber: '42024',
    unit: 'ton',
    aliases: ['mineral aggregate', 'type 17', 'gravel borrow', 'structural fill'],
  },
  {
    id: 'p-42026',
    name: 'Select Borrow',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '42026',
    unit: 'ton',
    aliases: ['select borrow', 'borrow', 'fill dirt', 'structural fill'],
  },
  {
    id: 'p-42010',
    name: 'Concrete Sand',
    category: 'Sand & gravel',
    cosSpec: 'Type 7',
    productNumber: '42010',
    unit: 'ton',
    aliases: ['concrete sand', 'sand', 'type 7', 'washed sand'],
  },
  {
    id: 'p-42023',
    name: 'Utility Sand',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '42023',
    unit: 'ton',
    aliases: ['utility sand', 'sand', 'bedding sand', 'pipe bedding'],
  },
  {
    id: 'p-52012',
    name: '3/8" Pea Gravel (Permeable Ballast)',
    category: 'Sand & gravel',
    cosSpec: 'Type 9',
    productNumber: '52012',
    unit: 'ton',
    aliases: ['pea gravel', 'permeable ballast', '3/8', 'type 9'],
  },
  {
    id: 'p-52011',
    name: '7/8" Washed Drain Gravel',
    category: 'Sand & gravel',
    cosSpec: 'Type 5',
    productNumber: '52011',
    unit: 'ton',
    aliases: ['drain gravel', 'washed rock', '7/8', 'type 5', 'drain rock'],
  },
  {
    id: 'p-52010',
    name: '1-1/2" Washed Drain Gravel',
    category: 'Sand & gravel',
    cosSpec: 'Type 4',
    productNumber: '52010',
    unit: 'ton',
    aliases: ['drain gravel', 'washed rock', '1-1/2', 'type 4', 'drain rock', 'septic rock'],
  },
  {
    id: 'p-42016',
    name: '3/8" Pea Gravel & Sand Blend',
    category: 'Sand & gravel',
    cosSpec: 'Type 26',
    productNumber: '42016',
    unit: 'ton',
    aliases: ['pea gravel sand blend', 'blend', 'type 26', '3/8'],
  },
  {
    id: 'p-62011',
    name: '5/8" Crushed Surfacing Top Course',
    category: 'Natural crushed',
    cosSpec: 'Type 1G',
    productNumber: '62011',
    unit: 'ton',
    aliases: ['5/8 minus', 'cstc', 'top course', 'crushed rock', 'type 1g', 'driveway rock'],
  },
  {
    id: 'p-62010',
    name: '1-1/4" Crushed Surfacing Base Course',
    category: 'Natural crushed',
    cosSpec: 'Type 2G',
    productNumber: '62010',
    unit: 'ton',
    aliases: ['1-1/4 minus', 'csbc', 'base course', 'road base', 'type 2g'],
  },
  {
    id: 'p-62014',
    name: 'COS 3/4" Crushed Gravel (Chips) 5/8" x 1/4" Clean Crushed',
    category: 'Natural crushed',
    cosSpec: 'Type 22',
    productNumber: '62014',
    unit: 'ton',
    aliases: ['chips', 'clean crushed', '3/4 crushed gravel', 'type 22'],
  },
  {
    id: 'p-62023',
    name: '1-1/4" Clear Crushed (1-1/4" x 5/8")',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '62023',
    unit: 'ton',
    aliases: [
      'clean crushed',
      '1-1/4 clean',
      '1-1/4 clear',
      'clear crushed',
      'clean rock',
      'ballast',
      'blue gray rock',
      'blue-gray',
    ],
  },
  {
    id: 'p-62016',
    name: '2" Clean Crushed',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '62016',
    unit: 'ton',
    aliases: ['clean crushed', '2 inch clean', 'ballast'],
  },
  {
    id: 'p-65016',
    name: '2" x 4" Quarry Spalls',
    category: 'Quarry spalls',
    cosSpec: '',
    productNumber: '65016',
    unit: 'ton',
    aliases: ['quarry spalls', 'spalls', 'riprap', 'rip rap', 'erosion'],
  },
  {
    id: 'p-65022',
    name: '4" x 8" Quarry Spalls',
    category: 'Quarry spalls',
    cosSpec: '',
    productNumber: '65022',
    unit: 'ton',
    aliases: ['quarry spalls', 'spalls', 'riprap', 'rip rap', 'erosion'],
  },
  {
    id: 'p-65011',
    name: 'RCA 5/8" Crushed Surfacing Top Course',
    category: 'RCA — reclaimed aggregate',
    cosSpec: 'Type 1R',
    productNumber: '65011',
    unit: 'ton',
    aliases: ['rca', 'recycled concrete', '5/8 recycled', 'type 1r', 'top course'],
  },
  {
    id: 'p-65010',
    name: 'RCA 1-1/4" Crushed Surfacing Base Course',
    category: 'RCA — reclaimed aggregate',
    cosSpec: 'Type 2R',
    productNumber: '65010',
    unit: 'ton',
    aliases: ['rca', 'recycled concrete', '1-1/4 recycled', 'type 2r', 'base course'],
  },
  {
    id: 'p-65021',
    name: 'RCA COS Type 17 (2" to 2-1/2" RCA & Gravel Borrow)',
    category: 'RCA — reclaimed aggregate',
    cosSpec: 'Type 17',
    productNumber: '65021',
    unit: 'ton',
    aliases: ['rca type 17', 'recycled borrow', 'recycled concrete', 'gravel borrow'],
  },
  {
    id: 'p-65015',
    name: 'RCA 2" x 4" Crushed Clean Spalls',
    category: 'RCA — reclaimed aggregate',
    cosSpec: '',
    productNumber: '65015',
    unit: 'ton',
    aliases: ['rca spalls', 'recycled spalls', 'recycled riprap'],
  },
  {
    id: 'p-65030',
    name: 'Asphalt Grindings',
    category: 'RCA — reclaimed aggregate',
    cosSpec: '',
    productNumber: '65030',
    unit: 'ton',
    aliases: ['asphalt grindings', 'grindings', 'recycled asphalt', 'rap'],
  },

  // Palmer Coking Coal products with no equivalent on the Kangley list
  {
    id: 'pcc-38-minus',
    name: '3/8" Minus Crushed Gravel',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['3/8 minus', 'crushed gravel', 'fine crushed'],
  },
  {
    id: 'pcc-34-clear',
    name: '3/4" Clear Crushed',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: [
      '3/4 clear',
      'clear crushed',
      'clean rock',
      '3/4 clean grey',
      'blue gray rock',
      'blue-gray',
      '3/4 clear decorative',
    ],
  },
  {
    id: 'pcc-2-minus-sp',
    name: '2" Minus Single Pass',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['2 minus', 'single pass', 'pit run crushed'],
  },
  {
    id: 'pcc-half-one-man',
    name: 'Half- to One-Man Rockery Rock',
    category: 'Quarry spalls',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['one man rock', 'half man rock', '0-1 man', 'rockery', 'large quarry rock', 'armor'],
  },
  {
    id: 'pcc-lava-rock',
    name: 'Lava Rock (all sizes)',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['lava rock', 'red rock', 'decorative'],
  },
  {
    id: 'pcc-cinder-chips',
    name: 'Cinder Chips (3/4" & 3/8")',
    category: 'Cinders & infield mix',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['cinder chips', 'cinders', 'track mix'],
  },
  {
    id: 'pcc-safeco-mix',
    name: 'Safeco Warning Track Mix',
    category: 'Cinders & infield mix',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['safeco mix', 'warning track', 'infield mix', 'ball field'],
  },
  {
    id: 'pcc-screened-sand',
    name: 'Screened Sand',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['screened sand', 'sand', 'fill sand'],
  },
  {
    id: 'pcc-sand-78-mix',
    name: 'Sand and 7/8" Mix',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['sand and 7/8', 'sand gravel mix', 'blend'],
  },
  {
    id: 'pcc-3way-topsoil',
    name: '3-Way Topsoil',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['3 way topsoil', 'three way', 'topsoil', 'garden soil'],
  },
  {
    id: 'pcc-4way-topsoil',
    name: '4-Way Topsoil',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['4 way topsoil', 'four way', 'topsoil', 'garden soil'],
  },
  {
    id: 'pcc-5050-topsoil',
    name: '50/50 Topsoil',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['50/50 topsoil', 'fifty fifty', 'topsoil sand mix'],
  },
  {
    id: 'pcc-golf-mix',
    name: 'Golf Course Mix',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['golf course mix', 'turf mix', 'sand soil mix'],
  },
  {
    id: 'pcc-compost',
    name: 'Compost',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['compost', 'organic amendment'],
  },
  {
    id: 'pcc-moo-doo',
    name: 'Organic Moo-Doo',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['moo doo', 'manure compost', 'organic compost'],
  },
  {
    id: 'pcc-nutra-mulch',
    name: 'Nutra-Mulch',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['nutra mulch', 'mulch', 'bark'],
  },
  {
    id: 'pcc-fine-bark',
    name: 'Fine Beauty Bark',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['fine beauty bark', 'beauty bark', 'bark', 'mulch'],
  },
  {
    id: 'pcc-medium-bark',
    name: 'Medium Beauty Bark',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['medium beauty bark', 'beauty bark', 'bark', 'mulch'],
  },
  {
    id: 'pcc-dark-mulch',
    name: 'Dark Mulch',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['dark mulch', 'mulch', 'bark'],
  },
  {
    id: 'pcc-bark-nuggets',
    name: 'Bark Nuggets',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['bark nuggets', 'nuggets', 'bark', 'mulch'],
  },
  {
    id: 'pcc-play-chips',
    name: 'Cedar Play Chips',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['cedar play chips', 'play chips', 'playground chips'],
  },
  {
    id: 'pcc-firewood',
    name: 'Firewood',
    category: 'Miscellaneous',
    cosSpec: '',
    productNumber: '',
    unit: 'cord',
    aliases: ['firewood', 'wood', 'cord'],
  },

  // Ryterra Quarry products with no equivalent elsewhere
  {
    id: 'ry-212-minus',
    name: '2-1/2" Minus',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['2-1/2 minus', '2.5 minus', 'coarse minus', 'pit run crushed'],
  },
  {
    id: 'ry-112-34-clear',
    name: '1-1/2" – 3/4" Clear',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['1-1/2 3/4 clear', 'clear crushed', 'drain rock', 'clean rock'],
  },
  {
    id: 'ry-212-78-clear',
    name: '2-1/2" – 7/8" Clear',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['2-1/2 7/8 clear', 'clear crushed', 'ballast', 'clean rock'],
  },
  {
    id: 'ry-rockery-2-4',
    name: '2-4 Man Rockery Rock',
    category: 'Quarry spalls',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['2-4 man rock', 'rockery rock', 'wall rock', 'armor rock'],
  },
  {
    id: 'ry-round-boulder',
    name: 'Round Boulder',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['round boulder', 'boulders', 'landscape rock'],
  },
  {
    id: 'ry-flats-steps',
    name: "Flat's / Step's / Square",
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '',
    unit: 'each',
    aliases: ['flats', 'steps', 'square', 'stone steps', 'slab'],
  },
  {
    id: 'ry-screened-fill',
    name: '2" Screened Fill',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['screened fill', 'fill', 'common borrow', 'cheap fill'],
  },
  {
    id: 'ry-recycle-212',
    name: '2-1/2" Recycled Aggregate',
    category: 'RCA — reclaimed aggregate',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['2-1/2 recycle', 'recycled rock', 'rca', 'recycled concrete'],
  },
  {
    id: 'ry-recycle-2x4',
    name: '2" x 4" Recycled Aggregate',
    category: 'RCA — reclaimed aggregate',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['2x4 recycle', 'recycled spalls', 'rca', 'recycled concrete'],
  },
  {
    id: 'ry-hog-fuel',
    name: 'Hog Fuel',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['hog fuel', 'wood waste', 'trail mulch'],
  },

  // Washington Rock Quarries products with no equivalent elsewhere
  {
    id: 'wr-114-tailings',
    name: '1-1/4" Minus Tailings',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '5961-1',
    unit: 'ton',
    aliases: ['tailings', '1-1/4 minus tailings', 'cheap base'],
  },
  {
    id: 'wr-trail-mix',
    name: '1/4" Minus Trail Mix',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '9990-1',
    unit: 'ton',
    aliases: ['trail mix', '1/4 minus', 'path fines', 'crusher fines'],
  },
  {
    id: 'wr-common-borrow',
    name: 'Pit Run Common Borrow',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '0890-1',
    unit: 'ton',
    aliases: ['pit run', 'common borrow', 'fill', 'backfill'],
  },
  {
    id: 'wr-8-minus-bank',
    name: 'Pit Run 8" Minus Out of the Bank',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '0898-3',
    unit: 'ton',
    aliases: ['8 minus', 'pit run', 'bank run', 'fill'],
  },
  {
    id: 'wr-4-minus-borrow',
    name: '4" Minus Gravel Borrow',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '1980-3',
    unit: 'ton',
    aliases: ['4 minus', 'gravel borrow', 'structural fill'],
  },
  {
    id: 'wr-class2-sand',
    name: 'Class 2 Sand',
    category: 'Sand & gravel',
    cosSpec: 'Class 2',
    productNumber: '1032-3',
    unit: 'ton',
    aliases: ['class 2 sand', 'sand', 'bedding sand'],
  },
  {
    id: 'wr-streambed-112',
    name: '1-1/2" x 4" Streambed Gravel',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '0101-3',
    unit: 'ton',
    aliases: ['streambed gravel', 'stream rock', 'river rock', 'cobble'],
  },
  {
    id: 'wr-streambed-4',
    name: '4" x 10" Streambed Gravel',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '0110-3',
    unit: 'ton',
    aliases: ['streambed gravel', 'stream rock', 'river rock', 'cobble'],
  },
  {
    id: 'wr-topsoil',
    name: 'Topsoil',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '1060-3',
    unit: 'cu yd',
    aliases: ['topsoil', 'soil', 'dirt'],
  },
  {
    id: 'wr-3way-soil',
    name: '3 Way Soil',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '1063-3',
    unit: 'cu yd',
    aliases: ['3 way soil', 'three way', 'topsoil', 'garden soil'],
  },
  {
    id: 'wr-5050-soil',
    name: '50/50 Soil Mix / Garden Mix',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '1064-3',
    unit: 'cu yd',
    aliases: ['50/50 soil', 'garden mix', 'soil compost blend'],
  },

  // Heidelberg Materials products with no equivalent elsewhere
  {
    id: 'hm-34-washed',
    name: '3/4" Washed Gravel',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '91050',
    unit: 'ton',
    aliases: ['3/4 washed gravel', 'washed gravel', 'round rock', 'drain rock'],
  },
  {
    id: 'hm-granulithic',
    name: 'Granulithic',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '91200',
    unit: 'ton',
    aliases: ['granulithic', 'topping mix', 'concrete topping'],
  },
  {
    id: 'hm-58-clear',
    name: '5/8" Clear Crushed',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '92355',
    unit: 'ton',
    aliases: [
      '5/8 clear crushed',
      'clear crushed',
      'clean rock',
      '5/8 clean',
      '5/8 clean crushed',
      'washed gravel',
      'clear crushed delivered',
    ],
  },
  {
    id: 'hm-58-crusher-run',
    name: '5/8" Commercial Crusher Run',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '92250',
    unit: 'ton',
    aliases: ['5/8 crusher run', 'commercial crusher run', 'crusher run'],
  },
  {
    id: 'hm-114-crusher-run',
    name: '1-1/4" Commercial Crusher Run',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '92150',
    unit: 'ton',
    aliases: ['1-1/4 crusher run', 'commercial crusher run', 'crusher run'],
  },
  {
    id: 'hm-heavy-riprap',
    name: 'Heavy Loose Rip Rap',
    category: 'Quarry spalls',
    cosSpec: '',
    productNumber: '93150',
    unit: 'ton',
    aliases: ['heavy rip rap', 'riprap', 'rip rap', 'armor rock', 'erosion'],
  },
  {
    id: 'hm-light-riprap',
    name: 'Light Loose Rip Rap',
    category: 'Quarry spalls',
    cosSpec: '',
    productNumber: '93200',
    unit: 'ton',
    aliases: ['light rip rap', 'riprap', 'rip rap', 'erosion'],
  },
  {
    id: 'hm-oversized-cobble',
    name: 'Oversized Unwashed Cobble',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '94000',
    unit: 'ton',
    aliases: ['oversized cobble', 'unwashed cobble', 'cobble', 'fill rock'],
  },

  {
    id: 'hm-pipe-bedding',
    name: 'Pipe Bedding',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '92246',
    unit: 'ton',
    aliases: ['pipe bedding', 'bedding sand', 'trench bedding'],
  },
  {
    id: 'hm-2way-topsoil',
    name: '2 Way Topsoil',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '97162',
    unit: 'cu yd',
    aliases: ['2 way topsoil', 'two way', 'topsoil'],
  },
  {
    id: 'hm-bioretention',
    name: 'Bioretention Soil',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '97163',
    unit: 'cu yd',
    aliases: ['bioretention soil', 'rain garden soil', 'bmp soil'],
  },
  {
    id: 'hm-cascade-med-compost',
    name: 'Cascade Medium Compost',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '97168',
    unit: 'cu yd',
    aliases: ['cascade medium compost', 'compost', 'medium compost'],
  },
  {
    id: 'hm-premium-garden-soil',
    name: 'Premium Garden Soil',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '97170',
    unit: 'cu yd',
    aliases: ['premium garden soil', 'garden soil', 'planting soil'],
  },
  {
    id: 'hm-wood-chip-mulch',
    name: 'Wood Chip Mulch',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '97171',
    unit: 'cu yd',
    aliases: ['wood chip mulch', 'wood chips', 'mulch'],
  },
  {
    id: 'hm-screened-loam',
    name: 'Screened Loam',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '97172',
    unit: 'cu yd',
    aliases: ['screened loam', 'loam', 'topsoil'],
  },
  {
    id: 'hm-2-screened-gravel-borrow',
    name: '2" Screened Gravel Borrow',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '91253',
    unit: 'ton',
    aliases: ['2 screened gravel borrow', 'gravel borrow', 'screened borrow', 'structural fill'],
  },

  // Heidelberg Materials — Snohomish / North King line items
  {
    id: 'hm-1-clear-neverett',
    name: '1" Clear Crushed (North Everett)',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '92126',
    unit: 'ton',
    aliases: ['1 clear crushed', 'clear crushed', 'drain rock', 'clean rock'],
  },
  {
    id: 'hm-14-minus-dust',
    name: '1/4" Minus Dust',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '92158',
    unit: 'ton',
    aliases: ['1/4 minus dust', 'quarry dust', 'crusher dust', 'fines', 'trail mix'],
  },
  {
    id: 'hm-crusher-run',
    name: 'Crusher Run',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '92270',
    unit: 'ton',
    aliases: ['crusher run', 'quarry run', 'single pass'],
  },
  {
    id: 'hm-1man-rock',
    name: '1 Man Rock / Boulders',
    category: 'Quarry spalls',
    cosSpec: '',
    productNumber: '93001',
    unit: 'ton',
    aliases: ['1 man rock', 'one man rock', 'boulders', 'rockery rock', 'wall rock'],
  },
  {
    id: 'hm-premium-rockery-load',
    name: 'Premium Mixed Rockery Load',
    category: 'Quarry spalls',
    cosSpec: '',
    productNumber: '93110',
    unit: 'ton',
    aliases: ['premium rockery', 'mixed rockery load', 'rockery rock', 'wall rock'],
  },

  // ICON Materials — Auburn plant washed sands
  {
    id: 'ic-mason-sand',
    name: 'Washed Mason Sand',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '2130',
    unit: 'ton',
    aliases: ['mason sand', 'masonry sand', 'washed mason sand', 'brick sand'],
  },

  // Franklin Ridge Sand and Gravel — pit products with no equivalent elsewhere
  {
    id: 'fr-4-screened-pit-run',
    name: '4" Screened Pit Run',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '6052',
    unit: 'ton',
    aliases: ['4 screened pit run', 'screened pit run', 'pit run', 'structural fill'],
  },
  {
    id: 'fr-fill-dirt',
    name: 'Fill Dirt',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '6054',
    unit: 'ton',
    aliases: ['fill dirt', 'fill', 'dirt', 'unscreened fill'],
  },
  {
    id: 'fr-3way-topsoil-ton',
    name: '3 Way Topsoil (per ton)',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '6055',
    unit: 'ton',
    aliases: ['3 way topsoil by the ton', 'three way topsoil', 'topsoil'],
  },
  {
    id: 'fr-mulch-solo',
    name: 'Mulch — Solo 12 yd load',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '6056',
    unit: 'load',
    aliases: ['mulch solo', 'mulch by the load', 'solo 12', 'mulch'],
  },
  {
    id: 'fr-mulch-super-solo',
    name: 'Mulch — Super Solo 18 yd load',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '6057',
    unit: 'load',
    aliases: ['mulch super solo', 'super solo 18', 'mulch by the load', 'mulch'],
  },
  {
    id: 'fr-mulch-tt',
    name: 'Mulch — Truck & Trailer 24 yd load',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '6058',
    unit: 'load',
    aliases: ['mulch truck and trailer', 'mulch t&t', 'tt 24', 'mulch by the load'],
  },
  {
    id: 'fr-screened-drain-4',
    name: 'Screened Drain 4" x 1-1/2"',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '6080',
    unit: 'ton',
    aliases: ['screened drain 4', 'drain rock', 'large drain rock'],
  },
  {
    id: 'fr-screened-drain-112',
    name: 'Screened Drain 1-1/2" x 3/4"',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '6081',
    unit: 'ton',
    aliases: ['screened drain 1-1/2', 'drain rock', 'septic rock'],
  },
  {
    id: 'fr-screened-sand-4',
    name: 'Screened Sand #4 Minus',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '6082',
    unit: 'ton',
    aliases: ['screened sand', '#4 minus sand', 'sand'],
  },
  {
    id: 'fr-paddock-arena-mix',
    name: 'Paddock Arena Mix',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '6083',
    unit: 'ton',
    aliases: ['paddock arena mix', 'arena mix', 'arena sand', 'horse arena'],
  },
  {
    id: 'fr-4-single-pass',
    name: '4" Single Pass',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '6175',
    unit: 'ton',
    aliases: ['4 single pass', 'single pass', 'shot rock', 'quarry run'],
  },
  {
    id: 'fr-streambed-cobble',
    name: 'Streambed Cobble',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '6951',
    unit: 'ton',
    aliases: ['streambed cobble', 'cobble', 'river rock', 'stream rock'],
  },

  // Carpinito Brothers — you-haul products sold by the cubic yard
  {
    id: 'cb-coarse-bark',
    name: 'Coarse Bark',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['coarse bark', 'nugget bark', 'pathway bark', 'bark'],
  },
  {
    id: 'cb-play-chips',
    name: 'Play Chips (cedar)',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['play chips', 'cedar chips', 'playground chips', 'dog run chips'],
  },
  {
    id: 'cb-78-drain',
    name: '7/8" Washed Drain Rock (per yard)',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['7/8 drain rock', 'washed drain rock yard', 'drain field rock'],
  },

  // McClain's Soil Supply — retail products sold by the cubic yard
  {
    id: 'mc-prep-soil',
    name: 'Prep Soil',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['prep soil', 'prep mix', 'planting prep', 'topsoil'],
  },
  {
    id: 'mc-dark-fine-bark',
    name: 'Dark Fine Bark',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['dark fine bark', 'dark bark', 'beauty bark', 'mulch'],
  },
  {
    id: 'mc-cedar-grove-compost',
    name: 'Cedar Grove Compost',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['cedar grove compost', 'compost', 'organic amendment'],
  },
  {
    id: 'mc-sawdust',
    name: 'Sawdust',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['sawdust', 'shavings', 'bedding'],
  },
  {
    id: 'mc-58-minus',
    name: '5/8" Minus Crushed Rock (per yard)',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['5/8 minus by the yard', 'crushed rock yard', 'driveway rock'],
  },
  {
    id: 'mc-114-minus',
    name: '1-1/4" Minus Crushed Rock (per yard)',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['1-1/4 minus by the yard', 'base course yard', 'road base'],
  },
  {
    id: 'mc-58-drain',
    name: '5/8" Drain Rock (per yard)',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['5/8 drain rock', 'drain rock yard', 'clean rock'],
  },
  {
    id: 'mc-112-drain',
    name: '1-1/2" Drain Rock (per yard)',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['1-1/2 drain rock', 'drain rock yard', 'septic rock'],
  },
  {
    id: 'mc-pea-gravel',
    name: 'Pea Gravel (per yard)',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['pea gravel by the yard', 'pea gravel', 'round rock'],
  },
  {
    id: 'mc-sand',
    name: 'Sand (per yard)',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['sand by the yard', 'sand'],
  },
  {
    id: 'mc-2x5-bull-rock',
    name: '2" x 5" Bull Rock (per yard)',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['bull rock', '2x5 bull rock', 'large drain rock', 'cobble'],
  },

  // CalPortland / Pioneer Aggregates — graded concrete aggregates and sands
  {
    id: 'cp-bank-run-gravel',
    name: 'Bank Run Gravel (City of Seattle Type 17)',
    category: 'Fill / structural',
    cosSpec: 'COS Type 17',
    productNumber: '8127',
    unit: 'ton',
    aliases: ['bank run gravel', 'bank run', 'type 17', 'mineral aggregate type 17', 'pit run'],
  },
  {
    id: 'cp-34-washed-sandy-gravel',
    name: '3/4" Washed Sandy Gravel (City of Seattle Type 26)',
    category: 'Sand & gravel',
    cosSpec: 'COS Type 26',
    productNumber: '8186',
    unit: 'ton',
    aliases: ['3/4 washed sandy gravel', 'sandy gravel', 'type 26', 'washed sandy gravel'],
  },
  {
    id: 'cp-112-12-ballast',
    name: '1-1/2" x 1/2" Ballast (City of Seattle Type 13)',
    category: 'Natural crushed',
    cosSpec: 'COS Type 13',
    productNumber: '8530',
    unit: 'ton',
    aliases: ['1 1/2 x 1/2 ballast', 'ballast', 'type 13'],
  },
  {
    id: 'cp-landscape-rock-7',
    name: '7" Plus Landscape Rock',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '8105',
    unit: 'ton',
    aliases: ['7 plus landscape rock', 'landscape rock', 'boulders', 'large rock'],
  },
  {
    id: 'cp-112-34-gravel',
    name: '1-1/2" x 3/4" Gravel',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '8420',
    unit: 'ton',
    aliases: ['1-1/2 x 3/4 gravel', 'graded gravel', 'clean gravel', 'drain rock'],
  },
  {
    id: 'cp-1-4-gravel',
    name: '1" x #4 Gravel (ASTM C33 #57)',
    category: 'Sand & gravel',
    cosSpec: 'ASTM C33 #57',
    productNumber: '8460',
    unit: 'ton',
    aliases: ['1 x 4 gravel', 'c33 57', '#57 stone', 'concrete aggregate'],
  },
  {
    id: 'cp-58-38-gravel',
    name: '5/8" x 3/8" Gravel',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '8480',
    unit: 'ton',
    aliases: ['5/8 x 3/8 gravel', 'graded gravel', 'clean gravel'],
  },
  {
    id: 'cp-34-4-gravel',
    name: '3/4" x #4 Gravel (ASTM C33 #67)',
    category: 'Sand & gravel',
    cosSpec: 'ASTM C33 #67',
    productNumber: '8481',
    unit: 'ton',
    aliases: ['3/4 x 4 gravel', 'c33 67', '#67 stone', 'concrete aggregate'],
  },
  {
    id: 'cp-4-8-sand',
    name: '#4 x #8 Sand',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '8700',
    unit: 'ton',
    aliases: ['#4 x #8 sand', 'coarse sand', 'graded sand'],
  },
  {
    id: 'cp-8-30-sand',
    name: '#8 x #30 Sand',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '8720',
    unit: 'ton',
    aliases: ['#8 x #30 sand', 'medium sand', 'graded sand'],
  },
  {
    id: 'cp-class1-sand',
    name: 'WSDOT Class 1 Sand',
    category: 'Sand & gravel',
    cosSpec: 'WSDOT Class 1',
    productNumber: '8724',
    unit: 'ton',
    aliases: ['class 1 sand', 'wsdot class 1', 'spec sand'],
  },
  {
    id: 'cp-34-38-crushed',
    name: '3/4" x 3/8" Crushed Gravel',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '8820',
    unit: 'ton',
    aliases: ['3/4 x 3/8 crushed', 'crushed gravel', 'clean crushed'],
  },
  {
    id: 'cp-38-4-crushed',
    name: '3/8" x #4 Crushed Gravel',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '8840',
    unit: 'ton',
    aliases: ['3/8 x 4 crushed', 'crushed gravel', 'chips'],
  },
  {
    id: 'cp-4-dust-crushed',
    name: '#4 x Dust Crushed Gravel',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '8870',
    unit: 'ton',
    aliases: ['#4 x dust', 'crusher fines', 'crushed fines', 'dust'],
  },

  // Miles Resources — Lakeview plant aggregates
  {
    id: 'mi-168',
    name: 'Driveway Rock (Recycled)',
    category: 'RCA — reclaimed aggregate',
    cosSpec: '',
    productNumber: '168',
    unit: 'ton',
    aliases: ['driveway rock', 'recycled driveway rock', 'rca'],
  },
  {
    id: 'mi-1000',
    name: 'Building Sand',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '1000',
    unit: 'ton',
    aliases: ['building sand', 'sand', 'masonry sand'],
  },

  // Squak Mtn Materials — recycled products with no equivalent elsewhere
  {
    id: 'sq-asphalt-cstc-34',
    name: 'RCA Asphalt CSTC 3/4" Minus',
    category: 'RCA — reclaimed aggregate',
    cosSpec: '',
    productNumber: '3100',
    unit: 'ton',
    aliases: [
      'asphalt cstc',
      'asphalt cstc 3/4 minus',
      '3/4 minus asphalt',
      'crushed asphalt',
      'recycled asphalt',
      'rap',
    ],
  },

  // Miles Sand & Gravel — Column 2 products with no equivalent elsewhere
  {
    id: 'msg-blending-sand',
    name: 'Blending Sand',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '1060',
    unit: 'ton',
    aliases: ['blending sand', 'blend sand', 'sand'],
  },
  {
    id: 'msg-buckshot',
    name: 'Buckshot',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '1105',
    unit: 'ton',
    aliases: ['buckshot', 'buck shot', 'unwashed pea gravel'],
  },
  {
    id: 'msg-138-drain',
    name: '1-3/8" Drain Rock',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '1130',
    unit: 'ton',
    aliases: ['1 3/8 drain', '1-3/8 drain rock', 'drain rock', 'septic rock'],
  },
  {
    id: 'msg-cobbles',
    name: 'Cobbles',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '1145',
    unit: 'ton',
    aliases: ['cobbles', 'cobble rock', 'river cobble'],
  },
  {
    id: 'msg-wall-backfill',
    name: 'Gravel Backfill for Walls',
    category: 'Fill / structural',
    cosSpec: 'WSDOT 9-03.12(2)',
    productNumber: '1187',
    unit: 'ton',
    aliases: ['gravel backfill for walls', 'wall backfill', 'wall drain rock'],
  },
  {
    id: 'msg-rr-ballast',
    name: '1-1/4" Railroad Ballast',
    category: 'Natural crushed',
    cosSpec: 'AREMA',
    productNumber: '1250',
    unit: 'ton',
    aliases: ['railroad ballast', 'rr ballast', '1-1/4 ballast', 'ballast'],
  },
  {
    id: 'msg-2-structural-fill',
    name: '2" Minus Structural Fill',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '1274',
    unit: 'ton',
    aliases: ['2 minus structural fill', 'structural fill', '2 minus fill'],
  },
  {
    id: 'msg-screened-pit-run',
    name: 'Screened Pit Run',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '1320',
    unit: 'ton',
    aliases: ['screened pit run', 'screened pitrun', 'pit run screened'],
  },
  {
    id: 'msg-trench-backfill',
    name: 'Trench Backfill',
    category: 'Fill / structural',
    cosSpec: '',
    productNumber: '1330',
    unit: 'ton',
    aliases: ['trench backfill', 'trench fill', 'backfill'],
  },

  // Randles Sand & Gravel products with no equivalent elsewhere
  {
    id: 'rd-small-cobble',
    name: 'Small Cobble',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['small cobble', 'cobble', 'river rock', 'round rock'],
  },
  {
    id: 'rd-large-cobble',
    name: 'Large Cobble',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['large cobble', 'cobble', 'river rock', 'round rock'],
  },
  {
    id: 'rd-field-stone',
    name: 'Field Stone',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['field stone', 'fieldstone', 'landscape rock'],
  },
  {
    id: 'rd-concrete-mix-38',
    name: '3/8" Concrete Mix',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['3/8 concrete mix', 'concrete mix', 'sand and gravel mix'],
  },
  {
    id: 'rd-concrete-mix-78',
    name: '7/8" Concrete Mix',
    category: 'Sand & gravel',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['7/8 concrete mix', 'concrete mix', 'sand and gravel mix'],
  },
  {
    id: 'rd-mound-sand',
    name: 'Mound Sand, ASTM C-33',
    category: 'Sand & gravel',
    cosSpec: 'ASTM C-33',
    productNumber: '',
    unit: 'ton',
    aliases: ['mound sand', 'astm c-33', 'septic sand', 'c33 sand'],
  },
  {
    id: 'rd-58-minus-blue',
    name: '5/8" Minus Blue (Lynch Creek)',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['5/8 minus blue', 'blue rock', 'lynch creek', 'basalt'],
  },
  {
    id: 'rd-114-minus-blue',
    name: '1-1/4" Minus Blue (Lynch Creek)',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['1-1/4 minus blue', 'blue rock', 'lynch creek', 'basalt'],
  },
  {
    id: 'rd-ballast-114-blue',
    name: '#5 Ballast 1-1/4" Clean Blue (Lynch Creek)',
    category: 'Natural crushed',
    cosSpec: '#5 Ballast',
    productNumber: '',
    unit: 'ton',
    aliases: ['#5 ballast', 'clean blue', 'ballast', 'lynch creek'],
  },
  {
    id: 'rd-2-clean-blue',
    name: '2" Clean Blue (Lynch Creek)',
    category: 'Natural crushed',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['2 clean blue', 'clean blue', 'blue rock', 'lynch creek'],
  },
  {
    id: 'rd-ex-loaded-rock',
    name: 'Extra Loaded Rock / HP (Lynch Creek)',
    category: 'Quarry spalls',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['ex loaded rock', 'hand placed rock', 'hp rock', 'armor rock'],
  },
  {
    id: 'rd-landscape-rock',
    name: 'Landscape Rock LL (Lynch Creek)',
    category: 'Decorative rock',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['landscape rock', 'll rock', 'decorative boulder'],
  },
  {
    id: 'rd-2-minus-concrete',
    name: '2" Minus Recycled Concrete',
    category: 'RCA — reclaimed aggregate',
    cosSpec: '',
    productNumber: '',
    unit: 'ton',
    aliases: ['2 minus concrete', 'recycled concrete', 'rca', 'crushed concrete'],
  },
  {
    id: 'rd-lawn-mix',
    name: 'Lawn Mix',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['lawn mix', 'topsoil', 'lawn soil'],
  },
  {
    id: 'rd-garden-mix',
    name: 'Garden Mix',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['garden mix', 'topsoil', 'garden soil'],
  },
  {
    id: 'rd-7030',
    name: '70/30 Sand & Compost',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['70/30', 'sand and compost', 'sand compost blend'],
  },
  {
    id: 'rd-fine-cascade-compost',
    name: 'Fine Cascade Compost',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['fine cascade compost', 'compost', 'cascade compost'],
  },
  {
    id: 'rd-medium-bark',
    name: 'Medium Bark',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['medium bark', 'beauty bark', 'bark'],
  },
  {
    id: 'rd-fine-bark',
    name: 'Fine Bark',
    category: 'Bark & mulch',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['fine bark', 'beauty bark', 'bark'],
  },

  // Carpinito Brothers blends
  {
    id: 'ao-compost',
    name: 'Compost Mulch, 100% Finished',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['compost', 'finished compost', 'compost mulch', 'organic amendment'],
  },
  {
    id: 'ao-potting-soil',
    name: 'Potting Soil, Pumice/Compost/Bark',
    category: 'Topsoil & compost',
    cosSpec: '',
    productNumber: '',
    unit: 'cu yd',
    aliases: ['potting soil', 'pumice blend', 'container mix', 'north country potting soil'],
  },

]
